import React from 'react'
import { PageFooterConsumer, AppToolbarPaidConsumer } from '../../../../components'
import { Outlet } from 'react-router-dom'
import { Container, Grid } from '@mui/material'
import { useStyles } from './style'
import { useIsOnTrial } from '../../../../hooks'

const PaidConsumerPrimaryLayout = ({ children }) => {
  const { isTrialBannerVisible } = useIsOnTrial()
  const classes = useStyles({ isTrialBannerVisible })
  return (
    <>
      <Container className={classes.appBarContainer} maxWidth={false} id='appbar-container'>
        <AppToolbarPaidConsumer />
      </Container>
      <Grid
        container
        direction='column'
        wrap='nowrap'
        className={classes.container}
      >
        <Grid item className={classes.mainContainer}>
          <main>
            {children || <Outlet />}
          </main>
        </Grid>
        <Grid item>
          <footer>
            <PageFooterConsumer />
          </footer>
        </Grid>
      </Grid>
    </>
  )
}

export default PaidConsumerPrimaryLayout
